import { Layout } from '@/views/performance';

export default {
    path: '/performance',
    component: Layout,
    children: [
        { path: 'summary', component: () => import('@/views/performance/Summary.vue') },
        { path: 'returns', component: () => import('@/views/performance/Returns.vue') },
    ]
};
